import { jsx as r } from "react/jsx-runtime";
import { useRef as l, useState as p, useEffect as c } from "react";
const u = {
  types: []
  // all types
}, m = ({
  updatePlace: s
}) => {
  const t = l(null), [a, n] = p("");
  return c(() => {
    if (!google.maps) return;
    const e = new google.maps.places.Autocomplete(t.current, u);
    return e.addListener("place_changed", () => {
      const o = e.getPlace();
      s(o), n(o.name ?? "");
    }), () => {
      e.unbindAll(), google.maps.event.clearInstanceListeners(e);
    };
  }, []), /* @__PURE__ */ r("input", { type: "text", id: "pac-input", className: "controls autoCompleteInput", placeholder: "Enter a location", value: a, ref: t, onChange: (e) => n(e.target.value) });
};
export {
  m as default
};
